import { render, staticRenderFns } from "./indexbar.vue?vue&type=template&id=3089d8da&scoped=true&"
import script from "./indexbar.vue?vue&type=script&lang=js&"
export * from "./indexbar.vue?vue&type=script&lang=js&"
import style0 from "./indexbar.vue?vue&type=style&index=0&id=3089d8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089d8da",
  null
  
)

export default component.exports